import { render, staticRenderFns } from "./PosthogEventsStatsTable.vue?vue&type=template&id=47d19b94"
import script from "./PosthogEventsStatsTable.vue?vue&type=script&lang=js"
export * from "./PosthogEventsStatsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports